import * as React from "react";
import { forwardRef } from "react";
const SvgSuitHearts = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 260" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g transform="translate(-288.15635,-348.0625)"><path style={{
      fontSize: "732.08221436px",
      fontStyle: "normal",
      fontWeight: "normal",
      fill: "#d40000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      fontFamily: "Lello"
    }} d="M 407.99992,606.58127 C 359.30689,554.26555 300.9848,491.57031 300.98478,417.2381 C 300.98478,394.67352 306.01529,377.74995 316.07638,366.46733 C 326.1374,355.18518 338.89059,349.54399 354.33598,349.54373 C 367.5471,349.54399 379.03056,354.77931 388.78642,365.24972 C 398.54202,375.72061 404.94652,387.15193 407.99992,399.54373 C 411.24682,387.15193 417.74812,375.72061 427.50402,365.24972 C 437.25962,354.77931 448.64622,349.54399 461.66392,349.54373 C 477.10912,349.54399 489.91442,355.18518 500.07992,366.46733 C 510.24502,377.74995 515.32787,394.67352 515.32792,417.2381 C 515.32807,491.56766 457.59088,554.48558 407.99992,606.58127 L 407.99992,606.58127 z " id="path2206" /></g></svg>;
const ForwardRef = forwardRef(SvgSuitHearts);
export default ForwardRef;